import { all, call, fork, put, select, takeLatest, take } from 'redux-saga/effects';
import { updateState } from 'core/actions/product/state';
import { decrementIndex, goToIndex, prev, setIndex } from 'core/slices/register';
import { EntityTypes } from 'constants/entities';
import { selectActionFeed, IActionFeed } from 'core/selectors/product/action/actionFeed';
import { RootState } from 'types';
import { Mode } from 'core/slices/session';
import { IViewer, updatePlayerState, updateViewerState, ViewerState } from 'core/slices/player';
import { PayloadAction } from '@reduxjs/toolkit';
import { selectSessionMode } from 'core/selectors/admin/sessionMode';

function* viewStateSaga(action: PayloadAction<IViewer>) {
  if (action.payload.state === ViewerState.RESTING) yield updatePageIds();
}

export function* updatePageIds(newIndex?: number) {
  const { feed, index }: IActionFeed = yield select(selectActionFeed);
  const courseProgressId = yield select((state: RootState) => state.state[EntityTypes.COURSE_PROGRESS]);
  const sessionAttemptId = yield select((state: RootState) => state.state[EntityTypes.SESSION_ATTEMPT]);
  const actionId = yield select((state: RootState) => state.state[EntityTypes.ACTION]);
  const moduleId = yield select((state: RootState) => state.state[EntityTypes.MODULE]);

  const mode: Mode = yield select(selectSessionMode);

  const page = feed[newIndex ?? index];

  if (!page) return;

  if (mode === Mode.LEARNING) {
    if (page.sessionAttemptId && page.sessionAttemptId !== sessionAttemptId)
      yield put(yield call(updateState, { type: EntityTypes.SESSION_ATTEMPT, id: page.sessionAttemptId }));

    if (page.courseProgressId && page.courseProgressId !== courseProgressId)
      yield put(yield call(updateState, { type: EntityTypes.COURSE_PROGRESS, id: page.courseProgressId }));
  }
  if (page.moduleId !== moduleId && page.moduleId)
    yield put(yield call(updateState, { type: EntityTypes.MODULE, id: page.moduleId, culprit: 3 }));

  if (page.actionId !== actionId && page.actionId)
    yield put(yield call(updateState, { type: EntityTypes.ACTION, id: page.actionId, culprit: 3 }));

  //This adds too many things to queue
  // if (page.courseNodeId !== courseNodeId && page.courseNodeId)
  //   yield put(yield call(updateState, { type: EntityTypes.COURSE_NODE, id: page.courseNodeId, culprit: 3 }));
}

function* setIndexSaga(action) {
  yield updatePageIds(action.payload);
}

function* prevSaga() {
  const { feed, index }: IActionFeed = yield select(selectActionFeed);

  if (index > 0) yield put(yield call(decrementIndex));
  yield put(yield call(updatePlayerState, { paused: true, culprit: 'prevSaga' }));

  // yield removeSceneIfNotRequired(true);
}

function* watchSetIndex() {
  yield takeLatest([setIndex, goToIndex], setIndexSaga);
}

function* watchPrev() {
  yield takeLatest(prev, prevSaga);
}

function* watchViewerState() {
  yield takeLatest(updateViewerState, viewStateSaga);
}

export function* pageSaga() {
  yield all([fork(watchPrev), fork(watchViewerState), fork(watchSetIndex)]);
}

export function* waitForPageTransition() {
  const viewState: IViewer = yield select((state: RootState) => state.core.player.state.viewer);
  // Bug fix: was `index > 0` which skipped the guard at the first feed position
  if (viewState.state === ViewerState.TRANSITIONING) yield take(updateViewerState);
}
